import { lazy } from "react";

const StrategyListV2 = lazy(() => import("features/Strategy/v2"));
const StrategyDetailV2 = lazy(() => import("features/Strategy/v2/Detail"));
const CodeBuilderV2 = lazy(() => import("features/Strategy/v2/CodeBuilder"));
const ETFBuilderV2 = lazy(() => import("features/Strategy/v2/ETFBuilder"));
const NoCodeBuilderV2 = lazy(() =>
  import("features/Strategy/v2/NoCodeBuilder")
);
const PublicStrategyDetailV2 = lazy(() =>
  import("features/Strategy/v2/PublicDetail")
);
const PromptfolioV2 = lazy(() => import("features/Strategy/v2/Promptfolio"));

export const STRATEGY_PATH = "/strategy";
export const STRATEGY_LIST_PATH = "/strategy/list";
export const STRATEGY_CREATE_PATH = "/strategy/create";
export const STRATEGY_EDIT_PATH = "/strategy/:id/edit";
export const STRATEGY_DETAIL_PATH = "/strategy/:id/detail";
export const STRATEGY_HOST_PATH = "/strategy/:id/host";
export const STRATEGY_HOST_PROGRESS_PATH = "/strategy/:id/host-progress";
export const STRATEGY_HOST_FORM_PATH = "/strategy/:id/host-form";
export const NO_CODE_BUILDER_PATH = "/strategy/:id/no-code-builder";
export const NO_CODE_BUILDER_EDIT_PATH = "/strategy/:id/ncb-edit";
export const NO_CODE_BUILDER_ADD_PATH = "/strategy/ncb";
export const ETF_BUILDER_PATH = "/strategy/:id/etf";

export const STRATEGY_DETAIL_PUBLIC_PATH = "strategy/:id/detail/public";

// V2 Routes
export const STRATEGY_V2_PATH = "/create";
export const STRATEGY_V2_LIST_PATH = "/create";
export const STRATEGY_V2_DETAIL_PATH = "/strategy/:id/detail";
export const STRATEGY_V2_EDIT_PATH = "/create/:id/edit";
export const NO_CODE_BUILDER_ADD_V2_PATH = "/create/ncb";
export const NO_CODE_BUILDER_V2_EDIT_PATH = "/create/:id/ncb-edit";
export const ETF_V2_BUILDER_PATH = "/create/:id/etf";
export const PROMPTFOLIO_V2_PATH = "/create/:id/promptfolio";

export const STRATEGY_DETAIL_V2_PUBLIC_PATH = "strategy/:id/detail/public";

export const strategyPublicRoutesV2 = [
  {
    path: STRATEGY_DETAIL_V2_PUBLIC_PATH,
    component: <PublicStrategyDetailV2 />,
  },
  {
    path: ETF_V2_BUILDER_PATH,
    component: <ETFBuilderV2 />,
  },
];

export const strategyPrivateRoutesV2 = [
  {
    path: STRATEGY_V2_PATH,
    component: <StrategyListV2 />,
  },
  {
    path: STRATEGY_V2_LIST_PATH,
    component: <StrategyListV2 />,
  },
  {
    path: PROMPTFOLIO_V2_PATH,
    component: <PromptfolioV2 />,
  },
  {
    path: STRATEGY_V2_DETAIL_PATH,
    component: <StrategyDetailV2 />,
  },
  {
    path: STRATEGY_V2_EDIT_PATH,
    component: <CodeBuilderV2 />,
  },
  {
    path: NO_CODE_BUILDER_V2_EDIT_PATH,
    component: <NoCodeBuilderV2 />,
  },
  {
    path: NO_CODE_BUILDER_ADD_V2_PATH,
    component: <NoCodeBuilderV2 />,
  },
];
